import { useStore } from 'vuex'
import { onMounted } from 'vue'

// TinyMCE imports
import "tinymce/tinymce"
import "tinymce/themes/silver";
import "tinymce/icons/default";
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css';
// TinyMCE plugin imports
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/autolink';

import Editor from '@tinymce/tinymce-vue'

import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue'
import AttachmentsEditor from "../AttachmentsEditor/AttachmentsEditor.vue";
import { ref } from 'vue'

export default {
    name: "CreatePost",
    components: {
        FormInputTextField,
        AttachmentsEditor,
        Editor
    },
    props: {
        groupName: {
            type: String,
            required: true,
            default: ""
        },
        groupDescription: {
            type: String,
            required: true,
            default: ""
        },
        groupId: {
            type: String,
            required: true
        },
        content: {
            type: Object,
            required: false,
            default: null
        },
        postId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'createPost', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        } 

        const postTitle = ref(props.content?.title ?? "")
        const postContent = ref(props.content?.description ?? "")
        const postFilesToAdd = ref([])
        const postFilesToRemove = ref([])

        const showInputErrors = ref(false)
        const isSubmitting = ref(false)

        const updateTextarea = (e) => {
            postContent.value = e.target.value
        }

        const validateInput = function (){
            return postTitle.value && postContent.value
        } 
        
        const submitCreatePost = async function () {
            if(isSubmitting.value){                
                return;
            }
            isSubmitting.value = true

            if (!validateInput()) {
                showInputErrors.value = true
                isSubmitting.value = false
                return;
            }

            let formData = new FormData()
            formData.append('title', postTitle.value)
            formData.append('content', postContent.value)

            postFilesToAdd.value.forEach(file => {
                formData.append('filesToAdd', file)
            })

            postFilesToRemove.value.forEach(fileId => {
                formData.append('filesToRemove', fileId)
            })
            
            if (!props.content) {
                const response = await store.dispatch('forum/submitCreatePost', {
                    body: formData,
                    id: props.groupId
                })
                window.location.href = response.redirectUrl
            } 
            else {
                const response = await store.dispatch('forum/submitEditPost', {
                    body: formData,
                    id: props.groupId,
                    postId: props.postId
                })
                window.location.href = response.redirectUrl
            }
        }

        onMounted(()=>{
            let retry = 0;
            (function addTabnavigationToToolbar(){
                const containerSelector = '.tox-toolbar__primary';
                const buttonSelector    = 'button[tabindex]';
              
                const buttons = document.querySelectorAll(`${containerSelector} ${buttonSelector}`);
              
                if (buttons.length === 0 && retry < 10) {
                  // nothing yet – try again in 500ms
                  retry++;
                  return setTimeout(addTabnavigationToToolbar, 500);
                } else if (buttons.length > 0) {
                    // once we have buttons, do the work
                    buttons.forEach(btn => btn.setAttribute('tabindex', 0));
                    buttons.forEach(btn => btn.addEventListener('keydown', e => e.stopPropagation()));

                    console.log("addTabnavigationToToolbar: added tabindex to buttons",buttons,"retried ",retry, "times");
                } else {
                    console.log("addTabnavigationToToolbar: FAILED in adding tabindex to buttons",buttons,"retried ",retry, "times");
                }
            })();
              

        })

        return {
            getLabel,
            postTitle,
            postContent,
            postFilesToAdd,
            postFilesToRemove,
            showInputErrors,
            submitCreatePost,
            updateTextarea,
            isSubmitting,
        }
    }
}